import { useMemo } from 'react';
import { useCostTracking } from '../../contexts/CostTrackingContext';
import {
    calculateCostsSinceStartOfYear,
    calculateCostsInPreviousMonth,
    calculateCostsInCurrentMonth,
} from '../../utils/costTrackingUtils';
import '../../css/CostTrackingDashboard.css';

/**
 * Summary footer showing year-to-date, previous month, and current month totals.
 * Hidden on mobile.
 */
export const CostSummaryFooter = () => {
    const { expenseRecords } = useCostTracking();

    const formatCurrency = (amount: number) =>
        new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

    const yearToDate = useMemo(
        () => calculateCostsSinceStartOfYear(expenseRecords),
        [expenseRecords],
    );

    const previousMonth = useMemo(
        () => calculateCostsInPreviousMonth(expenseRecords),
        [expenseRecords],
    );

    const currentMonth = useMemo(
        () => calculateCostsInCurrentMonth(expenseRecords),
        [expenseRecords],
    );

    const metrics = [
        { key: 'ytd', label: 'Costs since the beginning of the year', value: yearToDate },
        { key: 'prev-month', label: 'Costs in the previous month', value: previousMonth },
        { key: 'current-month', label: 'Costs in the current month', value: currentMonth },
    ];

    return (
        <div className="ct-summary-footer">
            {metrics.map((metric) => (
                <div key={metric.key} className="ct-summary-metric">
                    <span className="ct-summary-label">{metric.label}</span>
                    <span className="ct-summary-value">{formatCurrency(metric.value)}</span>
                </div>
            ))}
        </div>
    );
};
